// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1k-0 {\n  padding: 8px;\n}\n\n._1k-1 {\n  width: 20px;\n  height: 20px;\n}\n\n._1k-2 {\n  width: 100%;\n}\n\n._1k-3 {\n  flex: 1;\n  padding: 8px;\n  border: 1px solid var(--redo-colors-border-border-primary);\n  display: flex;\n  align-items: center;\n}\n\n._1k-3:focus-within {\n    border: 1px solid var(--redo-colors-border-border-primary-active);\n  }\n", ""]);
// Exports
export var askButton = "_1k-0";
export var icon = "_1k-1";
export var input = "_1k-2";
export var label = "_1k-3";
export default ___CSS_LOADER_EXPORT___;
